<template>
<div class="entries" v-bind:class="{ hideRejected: hideRejected }">

<div v-if="error" class="card"><p>{{ error.message }}</p></div>

<label class="toggleRejected"><shield-icon/> Rejected Entries <toggle-button v-model="hideRejected" :labels="{ checked: 'Hide', unchecked: 'Show'}" :width="60"/></label>

<h2 v-if="entriesThisMonth.length > 0">This Month</h2>
<transition-group name="fade" tag="div">
<entry  v-for="entry in entriesThisMonth" :key="entry.id" :entry="entry" @viewEntry="viewEntry"/>
</transition-group>

<h2 v-if="entriesLastMonth.length > 0">Last Month</h2>
<entry  v-for="entry in entriesLastMonth" :key="entry.id" :entry="entry" @viewEntry="viewEntry"/>

<h2 v-if="entriesEarlier.length > 0">Earlier</h2>
<entry v-for="entry in entriesEarlier" :key="entry.id" :entry="entry" @viewEntry="viewEntry"/>

<div v-if="end && entries.length === 0" class="none card">
<h2>No entries yet.</h2><p>See the HTML tab to insert this form on <code>{{form.domain}}</code></p>
</div>

<div v-if="end && entries.length !== 0" class="card"><p>No more entries to display</p></div>

<button v-if="offset !== 0 && !end" @click="loadMore" class="load">Load older entries</button>

<entry-modal v-if="selectedEntry !== null" :form="form" :entry="selectedEntry" @closeModal="closeModal"/>

</div>
</template>

<script>
import Entry from '@/components/Forms/Entry';
import EntryModal from '@/components/Forms/EntryModal';
import {
  ShieldIcon,
} from 'vue-feather-icons';
import FormsService from '@/services/Forms';

export default {
  props: ['form'],
  data() {
    return {
      entries: [],
      offset: 0,
      end: false,
      hideRejected: true,
      selectedEntry: null,
      error: null,
    };
  },
  async created() {
    if (this.$route.name === 'Form-entries-entryId') {
      const specificEntry = (await FormsService.getFormEntryByID(this.form.id, this.$route.params.entryId)
        .catch((error) => {
          if (error.response.status === 404) this.error = { message: 'No entry with that ID' };
        }));
      if (specificEntry && specificEntry.data.id) this.viewEntry(null, specificEntry.data);
    }

    const initEntries = (await FormsService.getFormEntries(this.form.id, this.form.offset || 0)).data;
    this.entries = initEntries.entries;
    this.offset = initEntries.offset;
    if (initEntries.end) this.end = true;
  },
  computed: {
    entriesThisMonth() {
      return this.entries.filter((entry) => {
        const first = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const last = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
        return (first < new Date(entry.created_at) && new Date(entry.created_at) < last);
      });
    },
    entriesLastMonth() {
      return this.entries.filter((entry) => {
        const first = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
        const last = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        return (first < new Date(entry.created_at) && new Date(entry.created_at) < last);
      });
    },
    entriesEarlier() {
      return this.entries.filter((entry) => {
        const first = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
        return (first > new Date(entry.created_at));
      });
    },
  },
  methods: {
    viewEntry(e, entry) {
      this.$router.push({ name: 'Form-entries-entryId', params: { id: this.form.id, entryId: entry.id } });
      this.selectedEntry = entry;
      if (document.querySelectorAll('.entry.selected').length !== 0) {
        document.querySelectorAll('.entry.selected')[0].classList.remove('selected');
      }
      if (e !== null) e.target.closest('.entry').classList.add('selected');
    },
    closeModal() {
      this.$router.push({ name: 'Form-entries' });
      this.selectedEntry = null;
      if (document.querySelectorAll('.entry.selected').length !== 0) {
        document.querySelectorAll('.entry.selected')[0].classList.remove('selected');
      }
    },
    async loadMore() {
      const moreEntries = (await FormsService.getFormEntries(this.form.id, this.offset)).data;
      if (moreEntries.entries.length === 0 || moreEntries.end) {
        this.end = true;
      } else {
        this.entries = this.entries.concat(moreEntries.entries);
        this.offset = moreEntries.offset;
      }
    },
  },
  sockets: {
    addEntry(data) {
      if (data.formID === this.form.id) {
        this.entries.unshift(data.entry);
      }
    },
  },
  components: {
    Entry,
    EntryModal,
    ShieldIcon,
  },
  async mounted() {
    this.$socket.emit('viewEntries', { id: this.form.id });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: all  0.8s ease-in-out !important;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}

.entries.hideRejected .rejected {
  display: none;
}

.toggleRejected {
  position: absolute;
  right: 25px;
  font-size: 80%;
  cursor: pointer;
}

.toggleRejected svg {
  vertical-align: middle;
  padding-bottom: 1px;
  padding-left: 5px;
}

.toggleRejected .vue-js-switch {
  vertical-align: top;
}

h2 {
  margin-bottom: 5px;
  padding-left: 15px;
  font-weight: 200;
  text-transform: uppercase;
}

h2:not(:first-of-type) {
  margin-top: 35px;
}

.none p { padding-left: 15px; }

.card:not(.none) p { text-align: center; }

button.load {
  width: 100%;
  padding: 15px;
  margin: 10px 0;
  font-weight: bold;
}

</style>
